<template>
  <div class="trade-record-item-info">
    <div class="recrd-title">
        <span :class="safeItem.type == 1? 'recrd-option-buy': 'recrd-option-sell'">{{ safeItem.type_text }}</span>
        <span class="recrd-type">{{ safeItem.coinname }}/{{ item.trade_coin }}</span>
        <span class="recrd-time">{{ safeItem.addtime }}</span>
        <span v-if="safeItem.status == 1" class="recor-btn" @click="cancelOrder(item.id)">{{ $t('common.cancel') }}</span>
        <span v-else style="float: right;" :class="safeItem.status == 2 ? 'data-up':'data-down' ">{{ safeItem.status == 2 ?  $t('tradelst.tab2'): safeItem.status == 3 ?  $t('tradelst.tab3'): safeItem.status }}</span>
    </div>
    <van-row>
        <van-col :span="9">
            <p>{{ $t('trade.price') }}({{ item.trade_coin }})</p>
            <span class="num">{{ safeItem.xjprice }}</span>
        </van-col>
        <van-col :span="8">
            <p>{{ $t('trade.num') }}({{ item.coinname }})</p>
            <span class="num">{{ safeItem.predict_num }}</span>
        </van-col>
        <van-col :span="7" class="txt-right">
            <p>{{ $t('trade.clinch') }}({{ item.coinname }})</p>
            <span class="num">-</span>
        </van-col>
    </van-row>
  </div>
</template>

<script>
export default {
  name: 'TradeRecordItem',
  props: ['item'],
  computed: {
    safeItem(){
      return this.item || {}
    }
  },
  watch:{
    item(){}
  },
  methods:{
    cancelOrder(id){
      this.$emit('cancel-Order',id)
    }
  }
}
</script>

<style>

</style>
